import { ReactNode, createContext, useContext, useState } from "react";
import DeleteModal from "./DeleteModal";
import { INews } from "models/broadcast";

interface INewsAlertProps {
  showDelete: (news: INews) => void;
}

export const NewsAlertContext = createContext<INewsAlertProps>(
  {} as INewsAlertProps
);

export const useNewsAlertContext = () =>
  useContext<INewsAlertProps>(NewsAlertContext);

interface IOpen {
  open: boolean;
  news: INews | null;
}

export function NewsAlertContextProvider({ children }: { children: ReactNode }) {
  const [openDelete, setOpenDelete] = useState<IOpen>({
    open: false,
    news: null,
  });

  const showDelete = (news: INews) => setOpenDelete({ open: true, news });
  const handleCloseDelete = () => setOpenDelete({ open: false, news: null });

  return (
    <NewsAlertContext.Provider
      value={{
        showDelete,
      }}
    >
      {openDelete.news && (
        <DeleteModal
          open={openDelete.open}
          news={openDelete.news}
          handleClose={handleCloseDelete}
        />
      )}

      {children}
    </NewsAlertContext.Provider>
  );
}

